export const REPORTS = {
  MM_VERIFICATION: {
    reportId: 100,
    reportName: 'Verification Report',
    reportKey: 'mm_verification_report',
    exportReportName: 'verification_report'
  },
  DM_RULES_USAGE: {
    reportId: 605,
    reportName: 'Rules Usage Report',
    reportKey: 'dm_rules_usage_report',
    exportReportName: 'rules_usage_report'
  },
} as const;
